import moment from 'moment';
import useSetExport from '@components/export/useSetExport';

function useSetViewerSessionsExport({ data, columns, interval }) {
  const headers = columns.map(({ title, dataKey }) => {
    return { title, key: dataKey, type: null };
  });

  const intervalStr = `(${moment(interval.from).format()} - ${moment(interval.to).format()})`;

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'dimensions-panel',
    widgetKey: 'user-sessions',
    widgetInfo: {
      title: `Subset of User Sessions (up to 1500) ${intervalStr}`,
    },
    data,
    headers,
  });
}

export default useSetViewerSessionsExport;
